import { render, staticRenderFns } from "./invoicesInfoBox.vue?vue&type=template&id=42fda396&"
import script from "./invoicesInfoBox.vue?vue&type=script&lang=ts&"
export * from "./invoicesInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports